import { useCallback, useState, useEffect } from 'react';

import { useGetUpliftRegions } from '@/pages/UpliftRates/hooks/useGetUpliftRegions';
import { useGetUpliftIndexes } from '@/pages/UpliftRates/hooks/useGetUpliftIndexes';
import { UpliftIndexTypePascalCaseEnum } from '@/graphql/contracts/_generated_/contracts';

export interface IndexOption {
  id: string;
  label: string;
}

export const useGetUpliftIndexesForCaps = () => {
  const { regions, loading: loadingRegions } = useGetUpliftRegions();
  const { getUpliftIndexes } = useGetUpliftIndexes();
  const [indexOptions, setIndexOptions] = useState<IndexOption[]>([]);
  const [isLoadingIndexes, setIsLoadingIndexes] = useState(false);

  const fetchAllIndexes = useCallback(async () => {
    if (!regions || regions.length === 0) return;

    setIsLoadingIndexes(true);
    try {
      const allOptions: IndexOption[] = [];

      for (const region of regions) {
        const indexes = await getUpliftIndexes({
          region: region.name,
          includeRates: false,
          type: UpliftIndexTypePascalCaseEnum.Published
        });

        if (indexes) {
          for (const index of indexes) {
            if (index.id) {
              allOptions.push({
                id: index.id,
                label: `${index.name} ${region.name}`
              });
            }
          }
        }
      }

      setIndexOptions(allOptions);
    } finally {
      setIsLoadingIndexes(false);
    }
  }, [regions, getUpliftIndexes]);

  useEffect(() => {
    if (!loadingRegions && regions.length > 0) {
      fetchAllIndexes();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingRegions, regions.length]);

  return {
    indexOptions,
    isLoadingIndexes: isLoadingIndexes || loadingRegions
  } as const;
};
